<template>
  <div class="header-container">
    <el-link :underline="false" class="link-left" @click="homeIndex">首页</el-link>
    <el-link class="link-left" icon="el-icon-location" :underline="false">{{ cityInfo.name }}</el-link>
    <el-link :underline="false" class="link-right" @click="merchantCenter">商家中心</el-link>
    <el-link :underline="false" class="link-right" :disabled="islogin!='true' ? true : false" @click="mineOrders"
             :title="islogin!='true' ? '暂未登录，无法查看我的订单' : ''">我的订单
    </el-link>
    <el-link :underline="false" class="link-right" @click="dialogVisible=true">服务分类</el-link>
    <label class="el-span" v-if="islogin!='true'">
      <el-link :underline="false" style="color: #333333;" @click="loginOut">你好，请登录</el-link>
      <span class="header-divider">|</span>
      <el-link :underline="false" style="color: #FE273B;" @click="registerAccount">免费注册</el-link>
    </label>
    <el-dropdown v-else class="el-span" trigger="click">
      <label>{{ loginInfo.userID }}<i class="el-icon-arrow-down el-icon--right"></i></label>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item><a @click="accountSetting">账号设置</a></el-dropdown-item>
        <el-dropdown-item><a @click="personal">个人中心</a></el-dropdown-item>
        <el-dropdown-item><a @click="logout">退出登录</a></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="" :visible.sync="dialogVisible" width="50%" :show-close="false" top="60px" :lock-scroll="true">
      <el-container>
        <el-aside style="width: auto;">
          <el-radio-group v-model="oneService" @change="changeOneService">
            <el-radio-button v-for="one of oneServiceList" :label="one.id">{{ one.name }}<i
                class="el-icon-arrow-right"/></el-radio-button>
          </el-radio-group>
        </el-aside>
        <el-main>
          <p style="font-size: 16px;color: #333333;margin-block-end: 0em;" class="SourceHanSansCN">
            {{ showOneService.name }}</p>
          <el-link type="info" v-for="(sonList,index) of showOneService.sonList" :underline="false"
                   @click="changeServiceClass(sonList)">{{ sonList.name }}
            <el-divider direction="vertical" class="divider-el" v-if="index!=showOneService.sonList.length-1"/>
          </el-link>
          <el-divider/>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
</template>
<script>
import $store from '@/store';
import {getCustomInfo, classificationSonsOnes} from '@/api/systemSetting';
import {getCityInfo, personal} from '@/api/interfaceApi'
import {serviceNode} from "@/api/cloudServiceApi";
import cityJson from "@/static/cityJson.json";

export default {
  name: "headerIndex",
  data() {
    return {
      dialogVisible: false,
      oneServiceList: [],
      oneService: 1,
      showOneService: {},
      islogin: false,
      loginInfo: {},
      cityInfo: null,
      cid: 0,
      CustomInfo: {},
      pinyinItem: [
        {type: 'beijing', name: '京'},
        {type: 'tianjin', name: '津'},
        {type: 'hebei', name: '冀'},
        {type: 'shanxi', name: '晋'},
        {type: 'neimenggu', name: '蒙'},
        {type: 'liaoning', name: '辽'},
        {type: 'jilin', name: '吉'},
        {type: 'heilongjiang', name: '黑'},
        {type: 'shanghai', name: '沪'},
        {type: 'jiangsu', name: '苏'},
        {type: 'zhejiang', name: '浙'},
        {type: 'fujian', name: '闽'},
        {type: 'jiangxi', name: '赣'},
        {type: 'shandong', name: '鲁'},
        {type: 'henan', name: '豫'},
        {type: 'hubei', name: '鄂'},
        {type: 'hunan', name: '湘'},
        {type: 'guangdong', name: '粤'},
        {type: 'guangxi', name: '桂'},
        {type: 'hainan', name: '琼'},
        {type: 'chongqing', name: '渝'},
        {type: 'sichuan', name: '川'},
        {type: 'guizhou', name: '黔'},
        {type: 'yunnan', name: '滇'},
        {type: 'xizang', name: '藏'},
        {type: 'shaanxi', name: '陕'},
        {type: 'gansu', name: '甘'},
        {type: 'qinghai', name: '青'},
        {type: 'ningxia', name: '宁'},
        {type: 'xinjiang', name: '新'},
        {type: 'anhui', name: '皖'},
      ]
    }
  },
  methods: {
    /*跳转注册界面*/
    registerAccount() {
      this.$router.replace({
        path: '/register'
      })
    },
    /*跳转登录页面*/
    loginOut() {
      this.$router.replace({
        path: '/login'
      })
    },
    homeIndex() {
      this.$router.replace({
        path: '/'
      })
    },
    changeOneService(value, event) {
      for (let one of this.oneServiceList) {
        if (one.id == value) {
          this.showOneService = one;
        }
      }
    },
    /*修改服务分类，调用商品查询功能*/
    changeServiceClass(row) {
      let routeData = this.$router.resolve({
        name: "AllService",
        query: {
          pName: this.cityInfo.name + '企业数字化服务云平台',
          one: this.showOneService.id,
          second: row.id
        },
        path: '/cloudPlatform/AllService',
      });
      window.open(routeData.href, '_blank')
    },
    /*个人中心*/
    personal() {
      this.$router.replace({
        path: '/personal/index',
        query: this.loginInfo
      })
      localStorage.setItem('personIndex', '/personal/editInformation');
    },
    /*退出登录*/
    logout() {
      console.log("  /\\_/\\ ");
      console.log(" ( o.o )");
      console.log("  > ^ <   ");
      console.log("   / \\ ");
      console.log("   / \\ ");
      console.log("   / __ \\ ");
      console.log("   / / \\ \\ ");
      console.log("   / / \\ \\ ");
      console.log("   / / \\ \\ ");
      console.log("   / / \\ \\ ");
      console.log("   / / \\ \\ ");
      console.log("   / / \\ \\ ");
      console.log("   /____/ \\____\\ ");
      $store.state.hasLogin = false;
      $store.state.loginData = {};
      $store.state.userInfo = {};
      $store.state.token = '';
      $store.state.loginInfo = {};
      sessionStorage.setItem("token", "");
      sessionStorage.setItem("hasLogin", "false");
      localStorage.setItem("token", "");
      sessionStorage.setItem("loginData", JSON.stringify(""));
      sessionStorage.setItem("userInfo", JSON.stringify(""));
      this.$router.replace({
        path: '/login'
      })
    },
    /*获取登录用户信息*/
    getCustomData() {
      if (this.cid != 0 && this.cid != undefined) {
        getCustomInfo({cid: this.cid, uid: this.cid}).then(res => {
          this.loginInfo = res.data;
          sessionStorage.setItem('CustomInfo', JSON.stringify(res.data))
        })
      }
    },
    // 网络请求 获取作者信息
    personalMethod() {
      if (this.cid != 0 && this.cid != undefined) {
        if (sessionStorage.getItem('personalInfo') == null || sessionStorage.getItem('personalInfo') == undefined) {
          personal({bid: this.cid, uid: this.cid}).then((res) => {
            if (res.code == 200) {
              sessionStorage.setItem('personalInfo', JSON.stringify(res.content));
            }
          })
        }
      }
    },
    /*获取服务分类*/
    getClassificationSonsOnes() {
      classificationSonsOnes().then(res => {
        if (res.code == 200) {
          this.oneServiceList = res.content.newClass;
          for (let one of this.oneServiceList) {
            if (one.id == 1) {
              this.showOneService = one;
            }
          }
        }
      })
    },
    /*账号设置*/
    accountSetting() {
      this.$router.replace({
        path: '/accountManagement/index',
        query: this.loginInfo
      })
      localStorage.setItem('accountIndex', '/accountManagement/bindMobile');
    },
    /*我的订单*/
    mineOrders() {
      this.$router.replace({
        path: '/orderManagement/index',
        query: this.loginInfo
      })
      localStorage.setItem('orderIndex', '/orderManagement/AllOrder');
    },
    /*商家中心*/
    merchantCenter() {
      let that = this;
      if (JSON.stringify(that.loginInfo) == '{}') {
        that.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            that.$router.replace({
              path: '/login'
            })
          }
        })
      } else {
        personal({
          bid: that.loginInfo.cid,
          cid: that.loginInfo.cid
        }).then(res => {
          if (res.code == 200) {
            if (res.content.shopId == 0 || res.content.shopId == null || res.content.shopId == undefined) {
              that.$alert('您的账号未开通店铺，请先认证企业再开通店铺', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  let routeData = that.$router.resolve({
                    name: "enterpriseCertification",
                    path: '/officialCloud/enterpriseCertification',
                  });
                  window.open(routeData.href, '_blank')
                }
              });
            }
          } else {
            /*跳转店铺详情*/
            let routeData = that.$router.resolve({
              name: "shop",
              path: '/storeManagement/shop',
              query: {
                id: res.content.shopId,
                pName: that.cityList.abridge + '企服务云'
              }
            });
            window.open(routeData.href, '_blank')
          }
        })
      }
    },
    /**获取地图定位*/
    getMapArea() {
      const that = this;
      if (!sessionStorage.getItem('locationInfo')){
        let url = window.location.href;
        // url = 'http://beijing.bangqichat.com'
        if (url.indexOf('www') > -1) {
          let str = url.split('://www.')
          let str1 = str[1].split('.');
          let pinyin = str1[0];
          for (let a = 0; a < this.pinyinItem.length; a++) {
            if (this.pinyinItem[a].type == pinyin) {
              for (let li of cityJson) {
                if (this.pinyinItem[a].name == li.abridge) {
                  this.cityList = li;
                  document.title = li.abridge+'企服务云';
                  that.getCityCode(li.lng, li.lat);
                }
              }
            }
          }
        } else {
          let str = url.split('://')
          let str1 = str[1].split('.');
          let pinyin = str1[0];
          for (let a = 0; a < this.pinyinItem.length; a++) {
            if (this.pinyinItem[a].type == pinyin) {
              for (let li of cityJson) {
                if (this.pinyinItem[a].name == li.abridge) {
                  this.cityList = li;
                  document.title = li.abridge+'企服务云';
                  that.getCityCode(li.lng, li.lat);
                }
              }
            }
          }
        }
      }
    },
    getCityCode(lat, lng) {
      getCityInfo(lat, lng, 1).then(res => {
        $store.state.locationInfo = res.content;
        this.cityInfo = res.content;
        sessionStorage.setItem("locationInfo", JSON.stringify(res.content));
        localStorage.setItem("locationInfo", JSON.stringify(res.content));
        serviceNode({cityCode: res.content.id, request: 'form', uid: 0}).then(obj => {
          if (obj.code == 200) {
            $store.commit('SET_ChildNodes', JSON.stringify(obj.content.list));
            for (let a = 0; a < obj.content.list.length; a++) {
              if (a == 0) {
                $store.commit('SET_CHILD_NODE', JSON.stringify(obj.content.list[0]));
              }
            }
          }
        })
      })
    },
  },
  mounted() {
    this.getCustomData();
    this.personalMethod();
    this.getMapArea();
  },
  beforeMount() {
    this.islogin = sessionStorage.getItem('hasLogin');
    this.cityInfo = JSON.parse(sessionStorage.getItem('locationInfo'));
    this.CustomInfo = sessionStorage.getItem('CustomInfo') ? sessionStorage.getItem('CustomInfo') : {};
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.getClassificationSonsOnes();
  }
}
</script>
<style scoped>
.header-container >>> .el-icon-location {
  color: #FE273B;
}

.header-container >>> .el-radio-group {
  width: min-content;
}

.header-container >>> .el-dialog__header {
  padding: 0;
}

.header-container >>> .el-dialog__body {
  padding: 0px;
}

.header-container >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FD2F37;
  background-color: white;
  border-color: white;
  box-shadow: none;
}

.header-container >>> .el-radio-button__inner {
  background: #F1F1F1;
  border: none;
  color: #666666;
  padding: 20px 120px 20px 30px;
  font-size: 16px;
  border-bottom: 1px solid #DDDDDD;
}

.header-container >>> .el-icon-arrow-right {
  position: absolute;
  right: 20px;
  color: #333333;
}

.header-container >>> .el-link.el-link--info {
  color: #666666;
  padding-top: 10px;
}

.header-container >>> .el-divider {
  background-color: #dddddd;
}

.header-container >>> .el-link--inner .el-divider {
  background-color: #666666;
}
</style>
<style scoped lang="scss">
.header-container {
  background: #fff;
  padding: 20px 18%;
  border-bottom: 1px solid #DCDCDC;
  min-width: 76rem;

  .link-left {
    margin-right: 45px;
    color: #333333;
  }

  .link-right {
    float: right;
    margin-left: 45px;
    color: #333333;
  }

  .el-span {
    color: #333;
    font-size: 14px;
    float: right;
    margin-left: 45px;
    display: inline-flex;

    .header-divider {
      color: #999999;
      padding: 0px 8px;
    }
  }
}
</style>
<style>
.el-dropdown-menu {
  width: fit-content;
}
</style>